<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="add-article-dialog"
  >
    <msg-reply-form
      ref="outform"
      @submit="submit"
    ></msg-reply-form>
  </sliderBarDialogShell>
</template>

<script>
import msgReplyForm from "@/components/wx/msg-reply-rule/msgReplyForm";

import {addMsgReply} from "@/api/wx/msgReply";

export default {
  name: "addMsgReplyRuleDialog",
  components: {
    msgReplyForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    formData:{
      type: Object,
      default(){
        return {}
      }
    }
  },

  data() {
    return {
      title: '新增自动回复规则'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {

      addMsgReply(form).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
       
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .add-article-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>

